// Users screen (admin only): list, role changes, invitations.
export const usersEn = {
  'users.subtitle': 'People who can sign in to the CMS.',
  'users.adminOnly': 'Only admins can manage users.',
  'users.invite': 'Invite user',
  'users.col.name': 'Name',
  'users.col.role': 'Role',
  'users.col.status': 'Status',
  'users.col.lastLogin': 'Last sign-in',
  'users.col.actions': 'Actions',
  'users.you': '(you)',
  'users.active': 'Active',
  'users.deactivated': 'Deactivated',
  'users.makeEditor': 'Make editor',
  'users.makeAdmin': 'Make admin',
  'users.deactivate': 'Deactivate',
  'users.reactivate': 'Reactivate',
  'users.toast.roleUpdated': 'Role updated',
  'users.toast.deactivated': 'User deactivated',
  'users.toast.reactivated': 'User reactivated',
  'users.deactivate.title': 'Deactivate {name}?',
  'users.deactivate.body': 'They will be signed out immediately and can’t sign in until reactivated.',

  'users.create.title': 'Invite User',
  'users.create.name': 'Name',
  'users.create.email': 'Email',
  'users.create.role': 'Role',
  'users.create.roleEditor': 'Editor — content, media, leads',
  'users.create.roleAdmin': 'Admin — also settings and users',
  'users.create.password': 'Temporary password',
  'users.create.passwordHint': 'At least {min} characters. They can change it from Profile.',
  'users.create.submit': 'Create user',
  'users.create.submitting': 'Creating…',
  'users.create.done': '{name} can now sign in. Share the password with them securely.',
  'users.create.centralHint': 'They sign in with a Digimasi account. You get a one-time link to share with them; it takes them to their Digimasi sign-in.',
  'users.link.action': 'Password link',
  'users.link.title': 'Password link for {name}',
  'users.link.titleNew': '{name} is invited',
  'users.link.body': 'Share this one-time link with {name}. It works until {expires} and takes them to their Digimasi sign-in. No email is sent, and you won’t see the link again.',
  'users.link.copy': 'Copy link',
  'users.link.copied': 'Link copied',
  'users.link.done': 'Done',
  'users.2fa.on': '2-step on',
  'users.2fa.reset': 'Reset 2-step',
  'users.2fa.resetTitle': 'Reset two-step verification for {name}?',
  'users.2fa.resetBody': 'Their authenticator app and recovery codes stop working. They set it up again at their next sign-in.',
  'users.2fa.resetBodyCentral': 'Their authenticator app and recovery codes stop working, for every Digimasi website they use. If they also use another Digimasi website, only they or Digimasi support can reset it, and nothing changes.',
  'users.2fa.resetDone': 'Two-step verification reset.',
  'users.2fa.resetDoneCentral': 'Done. If {name} also uses another Digimasi website, ask Digimasi support to reset it.',
} as const

export const usersId: Record<keyof typeof usersEn, string> = {
  'users.subtitle': 'Orang yang dapat masuk ke CMS.',
  'users.adminOnly': 'Hanya admin yang dapat mengelola pengguna.',
  'users.invite': 'Undang pengguna',
  'users.col.name': 'Nama',
  'users.col.role': 'Peran',
  'users.col.status': 'Status',
  'users.col.lastLogin': 'Masuk terakhir',
  'users.col.actions': 'Aksi',
  'users.you': '(Anda)',
  'users.active': 'Aktif',
  'users.deactivated': 'Dinonaktifkan',
  'users.makeEditor': 'Jadikan editor',
  'users.makeAdmin': 'Jadikan admin',
  'users.deactivate': 'Nonaktifkan',
  'users.reactivate': 'Aktifkan kembali',
  'users.toast.roleUpdated': 'Peran diperbarui',
  'users.toast.deactivated': 'Pengguna dinonaktifkan',
  'users.toast.reactivated': 'Pengguna diaktifkan kembali',
  'users.deactivate.title': 'Nonaktifkan {name}?',
  'users.deactivate.body': 'Pengguna akan langsung dikeluarkan dan tidak dapat masuk sebelum diaktifkan kembali.',

  'users.create.title': 'Undang Pengguna',
  'users.create.name': 'Nama',
  'users.create.email': 'Email',
  'users.create.role': 'Peran',
  'users.create.roleEditor': 'Editor — konten, media, prospek',
  'users.create.roleAdmin': 'Admin — juga pengaturan dan pengguna',
  'users.create.password': 'Kata sandi sementara',
  'users.create.passwordHint': 'Minimal {min} karakter. Pengguna dapat mengubahnya di Profil.',
  'users.create.submit': 'Buat pengguna',
  'users.create.submitting': 'Membuat…',
  'users.create.done': '{name} kini dapat masuk. Bagikan kata sandinya dengan aman.',
  'users.create.centralHint': 'Pengguna masuk dengan akun Digimasi. Anda akan dapat tautan sekali pakai untuk dibagikan; tautan itu membawa mereka ke akun Digimasi mereka.',
  'users.link.action': 'Tautan kata sandi',
  'users.link.title': 'Tautan kata sandi untuk {name}',
  'users.link.titleNew': '{name} sudah diundang',
  'users.link.body': 'Bagikan tautan sekali pakai ini ke {name}. Tautan berlaku sampai {expires} dan membawa mereka ke akun Digimasi mereka. Tidak ada email yang dikirim, dan tautan ini tidak ditampilkan lagi.',
  'users.link.copy': 'Salin tautan',
  'users.link.copied': 'Tautan disalin',
  'users.link.done': 'Selesai',
  'users.2fa.on': '2 langkah aktif',
  'users.2fa.reset': 'Reset 2 langkah',
  'users.2fa.resetTitle': 'Reset verifikasi dua langkah untuk {name}?',
  'users.2fa.resetBody': 'Aplikasi autentikator dan kode pemulihannya tidak berlaku lagi. Dia mengaktifkannya lagi saat masuk berikutnya.',
  'users.2fa.resetBodyCentral': 'Aplikasi autentikator dan kode pemulihannya tidak berlaku lagi, untuk semua website Digimasi yang dia pakai. Kalau dia juga memakai website Digimasi lain, hanya dia atau tim support Digimasi yang bisa mereset, dan tidak ada yang berubah.',
  'users.2fa.resetDone': 'Verifikasi dua langkah sudah direset.',
  'users.2fa.resetDoneCentral': 'Selesai. Kalau {name} juga memakai website Digimasi lain, minta tim support Digimasi untuk mereset.',
}
